import React, { useState, useEffect, Fragment } from 'react';
import RespuestaC from './../Consulta/respuesta';
import LoaderScreen from '../layout/LoaderScreen';
import { ReembolsoSevices } from '../../Services';
import MensajeAdvertencia from '../../Services/MensajeAdvertencia';

import Popover from 'react-tiny-popover';
import DateRangePicker from 'react-daterange-picker'
import 'react-daterange-picker/dist/css/react-calendar.css'
import Moment from 'moment';
import { useTranslation } from 'react-i18next';

const Indice = (props) => {
    const { t } = useTranslation();
    var hoy = new Date();
    var anoPasado = hoy.setMonth(hoy.getMonth() - 48);
    const [FechaBoleto, setFechaBoleto] = useState(Moment(new Date())); 
    const [ActivarPopoverFechas, setActivarPopoverFechas] = useState(false);
    const [Boleto, setBoleto] = useState(""); 
    const [LongitudMaxBoleto] = useState(10);
    const [MostrarRespuesta, setMostrarRespuesta] = useState(false);
    const [ActivarLoader, setActivarLoader] = useState(false);
    const [Respuesta, setRespuesta] = useState([]);

    function solonumeros(inputtxt) {
        try {
            var numbers = /^[0-9]+$/;
            if (inputtxt.match(numbers)) {
                return true;
            }
            else {
                return false;
            }
        } catch (ex) {
            console.log('error', ex)
            return false;
        }
    }
    function AsignarFecha(value) {
        setFechaBoleto(value);
        setActivarPopoverFechas(false);
    }
    function AsignarValorBoleto(params) {
        if (solonumeros(params)) {
            if (params.length < LongitudMaxBoleto) {
                setBoleto(params);
            }
        }
    }

    async function BuscarResultado() {

        if (Boleto !== "") {
            setActivarLoader(true);
            try {

                const peticion = await ReembolsoSevices.ObtenerEstatusReembolso(Boleto, Moment(FechaBoleto).format("MM/DD/YYYY"));
                
                if (peticion.status == 200) {
                    setActivarLoader(false);
                    
                    if (peticion.resp.length > 0) {
                        const posibleError = peticion.resp[0].Comment;
                        if (posibleError && posibleError.includes("ERROR")) {
                            const errorMatch = posibleError.match(/ERROR (\d+)/);
                            const errorCode = errorMatch ? errorMatch[1] : null;
                            const errorMsg = errorCode ? t(`apiErrores.${errorCode}`, t('apiErrores.default') + posibleError) : t('apiErrores.default') + posibleError;
                            
                            setActivarLoader(false);
                            setMostrarRespuesta(false);
                            MensajeAdvertencia(t('paso4.errorTitulo', "Advertencia"), errorMsg, "warning", t('paso4.btnReintentar', "Reintentar"));
                        } else {
                            window.scrollTo(0, document.body.scrollHeight);
                            setRespuesta(peticion.resp);
                            setMostrarRespuesta(true);
                        }
                    }
                    else {
                        setActivarLoader(false);
                        setMostrarRespuesta(false);
                        MensajeAdvertencia(t('paso4.errorTitulo', "Advertencia"), t('apiErrores.2023', "No fué posible encontrar el número de solicitud ingresado. intente nuevamente"), "warning", t('paso4.btnReintentar', "Reintentar"));
                    }
                }

            } catch (error) {
                setActivarLoader(false);
            }

        } else {
            MensajeAdvertencia(t('paso4.errorTitulo', "Advertencia"), t('indice.errorCamposReq', "Debe ingresar número de solicitud y la fecha del mismo, que recibió en su correo electrónico."), "warning", t('paso4.btnReintentar', "Reintentar"));
        }
    }
    useEffect(() => {

        
        setBoleto("");
    }, [])



    return (
        <>
            <LoaderScreen props={ActivarLoader} mensaje={t('indice.validandoBoleto')} />

            <div className=' container _pt-60 _pb-20' >
                <div className='row'>
                    <div className='col-md-12 _pb-20'>
                        <h2 style={{color:"#565657"}}>
                            {t('indice.bienvenido')}<br />
                            <small>{t('indice.conocePolitica')}</small>
                        </h2>

                    </div>

                    <div className='col-md-4'></div>
                    <div className='col-md-4'>
                        <h2 className="text-center _pb-15 _pt-20 _br-15 _c-w _bg-p" style={{ fontSize: "1.3em", fontWeight: "normal", borderRadius: 20 }}> {t('indice.queNecesita')}</h2>
                    </div>
                    <div className='col-md-4'></div>
                    <div className='col-md-12 _pb-50'>
                        <h3 className=" text-center" ><span style={{color:"#575756"}}>{t('indice.estamosAsistir')}</span></h3>
                    </div>
                    <div className='col-md-5'>
                        <div className=" _p-30 _bg-w _br-4 theme-search-area-vert" style={{ border: "1px solid #dadada", minHeight: "400px", borderRadius: 15 }}>
                            <div className="row " data-gutter="20">
                                <div className="col-md-12 ">
                                    <h4 className='_c-p'>{t('indice.verificarEstado')}</h4>
                                </div>
                                <div className="col-md-12 ">
                                    <h5 className=" _c-dark"><span className="_c-p">*</span>  {t('indice.fechaSolicitud')}</h5>
                                    <div className="theme-payment-page-form-item form-group">
                                        <Popover
                                            containerClassName={"text-center"}
                                            containerStyle={{ borderRadius: '0px 0px 10px 10px', border: '1.2px solid #CD171A', background: "#f8f8f8", zIndex: "999" }}
                                            arrowStyle={{ background: "#f8f8f8" }}
                                            isOpen={ActivarPopoverFechas}
                                            position={'bottom'}
                                            disableReposition
                                            onClickOutside={() => setActivarPopoverFechas(false)}
                                            content={({ position, nudgedLeft, nudgedTop, targetRect, popoverRect }) => (
                                                <>
                                                    <DateRangePicker
                                                        minimumDate={anoPasado}
                                                        maximumDate={new Date()}
                                                        selectedLabel={'Fecha en la cual emitió la solicitud de reembolso'}
                                                        locale={Moment.locale('es')}
                                                        showLegend={true}
                                                        firstOfWeek={1}
                                                        numberOfCalendars={1}
                                                        value={FechaBoleto}
                                                        onSelect={(ev) => AsignarFecha(ev)}
                                                        singleDateRange={false}
                                                        selectionType={'single'}
                                                    />
                                                </>
                                            )}
                                        >
                                            <input className="form-control seleccionable"
                                                onClick={() => setActivarPopoverFechas(!ActivarPopoverFechas)}
                                                type="text"
                                                value={Moment(FechaBoleto).format("YYYY/MM/DD")}
                                                placeholder="DD/MM/AAAA" />

                                        </Popover>

                                    </div>
                                </div>
                                <div className="col-md-12 _pt-20">
                                    <h5 className=" _c-dark"><span className="_c-p">*</span>  {t('indice.nroSolicitud')}</h5>
                                    <div className="theme-payment-page-form-item form-group">
                                        <input
                                            onChange={(ev) => AsignarValorBoleto(ev.target.value)}
                                            value={Boleto}
                                            className="form-control"
                                            type="text"
                                            placeholder={t('indice.nroSolicitud')}
                                            data-provide="typeahead" />

                                    </div>
                                </div>
                                <div className="col-md-12 _pt-30">
                                    <a href="#respuesta" style={{ lineHeight: "37px" }} onClick={() => BuscarResultado()} className="seleccionable theme-search-area-submit _mt-0 theme-search-area-submit-curved theme-search-area-submit-curved2">
                                        <span className=" _c-w">{t('indice.consultar')}</span>
                                    </a>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    <div className='col-md-1'></div>
                    <div className='col-md-5'>
                        <div className=" _p-30 _bg-w _br-4 theme-search-area-vert" style={{ border: "1px solid #dadada", minHeight: "400px", borderRadius: 15 }}>
                            <div className="row " data-gutter="20">
                                <div className="col-md-12 ">
                                    <h4 className='_c-p'>{t('indice.solicitarReembolso')}</h4>
                                </div>
                                <div className="col-md-12 ">
                                    <ul >
                                        <li>{t('indice.generePorSeparado')}</li>
                                        <li>{t('indice.recibiraCorreo')}</li>
                                        <li>{t('indice.alValidar')}</li>

                                    </ul>
                                </div>

                                <div className="col-md-12 _pt-40">
                                    <br />
                                    <a style={{ lineHeight: "37px" }} href={'/solicitar'} className="seleccionable theme-search-area-submit _mt-0 theme-search-area-submit-curved theme-search-area-submit-curved2">
                                        <span className=" _c-w">{t('indice.solicitar')}</span>
                                    </a>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className='col-md-12'>

                        <Fragment>
                            {MostrarRespuesta ? (
                                <RespuestaC aBoleto={Respuesta} onClose={() => setMostrarRespuesta(false)} />
                            ) : null}
                        </Fragment>

                    </div>
                    <div className='col-md-12 _pt-30'>
                        <h4 className='_c-p'>{t('indice.importante')}</h4>
                        <p>{t('indice.antesDeSolicitar')}</p>
                        <ul>
                            <li>{t('indice.politicasProcedimientos')} <a href='https://aviorair.com/faq' className='hover-Oscuro _c-p' target='_Blank'><b>aviorair.com/faq</b></a></li>
                            <li>
                                {t('indice.condicionesBeneficios')} <a href='https://aviorair.com/tarifas' className='hover-Oscuro _c-p' target='_Blank'><b>aviorair.com/tarifas</b></a>
                            </li>
                        </ul>
                    </div>

                </div>
            </div>
            
        </>
    );
}

export default Indice;